import Details from './details'
import List from './list'

export {
  Details,
  List
}
